import { render } from "./TheMesurement.vue?vue&type=template&id=7954b137"
import script from "./TheMesurement.vue?vue&type=script&lang=js"
export * from "./TheMesurement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__